import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { HasGroupDirective } from '../directives/has-group.directive';
import { HasNotGroupDirective } from '../directives/has-not-group.directive';
import { HasAllGroupsDirective } from '../directives/has-all-groups.directive';
import { oktaAuthComplete } from './okta-configs';
import { OKTA_AUTH, OKTA_CONFIG, OktaAuthGuard, OktaAuthStateService } from '@okta/okta-angular';

export function provideAppAuth(): EnvironmentProviders {
  return importProvidersFrom(
    HasGroupDirective,
    HasNotGroupDirective,
    HasAllGroupsDirective,
    AuthService,
    OktaAuthStateService,
    OktaAuthGuard
  );
}

export function provideOktaAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: OKTA_CONFIG, useValue: { oktaAuthComplete } },
    { provide: OKTA_AUTH, useValue: oktaAuthComplete },
  ]);
}
